export { AuthenticationService } from './lib/AuthenticationService';
export { AzureAuthenticationService } from './lib/AzureAuthenticationService';
export { UnifiedAuthenticationService } from './lib/UnifiedAuthenticationService';
export { useAuthenticationService } from './react/useAuthenticationService';
export { AuthenticatingLoader } from './react/components/AuthenticatingLoader';
export { LoginComponent } from './react/components/LoginComponent';
export type { AuthProvider, AuthUser, AuthConfig, FetchWithAuth } from './types';
export { fetchWithAuth } from './util/fetchWithAuth';
export { loadAppConfig } from './util/loadAppConfig';
export { 
  getAuthConfig, 
  createMsalConfig, 
  getInitialProvider, 
  needsAuthentication 
} from './utils/configUtils';
export type { AuthConfig as ParsedAuthConfig, AppConfig } from './utils/configUtils';
